import { useAppSelector } from '@/shared/hooks';
import { getName } from '@/shared/lib';

import { organizationModel } from '@/entities/organization';
import { userModel } from '@/entities/user';

import { EMPTY_VALUE } from '../config';

// Created.By is a user id (or email/"diagnocat" for legacy keys); resolve it to the
// organization member's name when possible, otherwise show the raw value.
export const useResolveApiKeyAuthor = () => {
  const members = useAppSelector(organizationModel.selectors.selectAllUsers);
  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  return (by?: string): string => {
    if (!by) {
      return EMPTY_VALUE;
    }

    const member = members?.find((current) => current.UserID === by);

    if (!member) {
      return by;
    }

    const name = getName(
      member.PersonalData?.FirstName,
      member.PersonalData?.LastName,
      { userLocale },
    ).trim();

    return name || by;
  };
};
